var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"anchor-app-extra":""}},[_c('anchor-popup',{staticStyle:{"z-index":"204 !important"}}),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }